export const GET_CHANGELOG = `
  query getChangelog {
    changelog {
      versionLabel
      description
      date
    }
  }
`;

export const UPDATE_CLIMBER_FACETS_SCORES = `
  mutation updateClimberFacets($input: ClimberFacetsInput!) {
    updateClimberFacets(input: $input) {
      facet
    }
  }
`;

export const GET_MY_FEATURES = `
  query getMyFeatures {
    getMyFeatures {
      path
      features
    }
  }
`;

export const GET_CONTENT_SUBSCRIPTIONS_FOR_ENTITY = `
  query getContentSubscriptionsForEntity($parentID: String!) {
    getContentSubscriptionsForEntity(parentID: $parentID) {
      id
      path
      parentID
      shardID
      contractTTL
      featureIDs
    }
  }
`;

export const CREATE_CLIMBER_SUBSCRIPTION = `
  mutation createClimberSubscription($input: CreateClimberSubscriptionInput!) {
    createClimberSubscription(input: $input) {
      id
      parentID
      featureIDs
    }
  }
`;

export const CREATE_OR_UPDATE_CONTENT_SUBSCRIPTION = `
  mutation createOrUpdateContentSubscription($input: ContentSubscriptionInput!) {
    createOrUpdateContentSubscription(input: $input) {
      id
      path
      parentID
      featureIDs
    }
  }
`;

export const GET_LOGO = `
query getLogo($districtID: String!) {
  getLogo(districtID: $districtID) {
    logo
    error
  }
}`;

export const UPDATE_LADDER_PROGRESS = `
  mutation updateLadderProgress($input: LadderProgressInput!) {
    updateClimberLadderProgress(input: $input) {
      highScore
      maxScore
      ladderId
      learnosityReference
      learnositySessionId
      externalRegistrationId
      numberOfSessions
      overallStatus
      completeDate
    }
  }
`;

export const GET_CMS_REPORTS = `
query getCMSReports {
  cmsReports {
    description
    id
    availableRoles
    embeddableReportId 
    developmentReportId
    icon {
      url
    }
    name
    order
    productPlan {
      code
    }
    productionReportId
    route
  }
}`;

export const GET_CMS_AWARDS = `
  query getCMSAwards {
    cmsAwards {
      awardRule
      awardType
      awardDescription
      image {
        url
        alt
      }
      completionMessage
      id
      name
      productPlan {
        code
        id
      }
      requiredClimbs
      requiredPlan
      requiredCourses
      title
      certificateConfig {
        theme
        skills {
          skill
        }
        badgeImage {
          url
          alt
        }
        logoImage {
          url
          alt
        }
        descriptionText
        metadata
      }
    }
  }
  `;

export const GET_CMS_FACET_TYPES = `
  query getCMSFacetTypes {
    cmsClimberFacetTypes {
      color
      textColor
      facet
      profileOrder
      emptyButtonTheme
      emptyTextColor
      description
      displayOnProfile
      longLabel
      id
      plan
      maxResults
      name
      scoringType
      resultsHeader
      ctaText
      ctaPath
      emptyColor
      emptyImage {
        url
      }
    }
  }
`;

// input CompleteAwardInput {
//   awardId: String!
//   awardType: String!
//   shardID: String!
//   userPath: String!
// }
export const COMPLETE_AWARD = `
  mutation completeAward($input: CompleteAwardInput!) {
    completeAward(input: $input) {
      id
      awardID
      climberID
      parentID
      completedAt
      path
      shardID
  }
}`;

export const GET_MY_AWARDS = `
query getMyAwards {
  getAwards {
    completedAt
    id
    path
    shardID
    awardID
  }
}`;

// Legacy query - deprecated, use GET_MY_AWARDS instead
// export const GET_AWARDS_BY_PATH = `
// query getAwardsByPath($path: String, $shardID: String!) {
//   getAwards(
//     path: $path
//     shardID: $shardID
//   ) {
//     completedAt
//     id
//     path
//     shardID
//     awardID
//   }
// }`;

export const GET_AWARDS_BY_PARENT_ID = `
query getAwardsByParentID($parentID: String!) {
  getAwardsByParentID(parentID: $parentID) {
    completedAt
    id
    path
    shardID
    awardID
    parentID
    climberID
  }
}`;

export const GET_AWARDS_BY_SECTION_ID = `
query getAwardsBySectionId($sectionId: String!, $nextToken: String, $limit: Int) {
  getAwardsBySectionId(sectionId: $sectionId, nextToken: $nextToken, limit: $limit) {
    awards {
      climberID
      awardID
      completedAt
    }
    nextToken
  }
}`;

export const GET_HAT_STATUSES_BY_CLIMBER_ID = `
query getHatStatusesByClimberID($climberId: String!) {
  getHatStatusesByClimberID(climberId: $climberId) {
    hatId
    statuses
  }
}`;

export const GET_CMS_FACETS = `
  query getCMSFacets($cacheKey: Int) {
    cmsClimberFacets(cacheKey: $cacheKey) {
      color
      secondaryColor
      longLabel
      description
      facet
      facetCode
      icon
      iconifyIcon      
      type
      variable
    }
  }
`;

export const GET_CMS_CAREER_CLIMB = `
  query getCMSCareerClimb($id: ID!, $drafts: Boolean, $cacheKey: Int) {
    cmsCareerClimb(id: $id, drafts: $drafts, cacheKey: $cacheKey) {      
      id
      reference
      learnosityTag
      image {
        url
      }
      instructionalLevel
      ladders {
        id
        order
        assessments {
          assessment
          active
          assessmentType
          productPlan {
            name
            code
          }
        }
        estimatedTime
        experiencePoints
        image {
          url
        }
        instructionalLevel
        name
        shortDescription
        ladderType
        topics {
          isSubTopic
          name
        }
      }
      learningObjectives {
        objective
      }
      longDescription
      name
      productPlan {
        code
      }
      shortDescription
      topics {
        isSubTopic
        sortOrder
        name
        displayIcon {
          url
        }
      }
    }
  }
`;

export const GET_CMS_CAREER_CLIMBS = `
  query getCareerClimbs($drafts: Boolean, $cacheKey: Int) {
    cmsCareerClimbs(drafts: $drafts, cacheKey: $cacheKey) {
      id
      reference
      learnosityTag
      image {
        alt
        url
      }
      productPlan {
        code
      }
      instructionalLevel
      ladders {
        order
        experiencePoints
        id
        name
        estimatedTime
        assessments {
          id
          assessment
          active
        }
      }
      longDescription
      name
      shortDescription
      topics {
        id
        name
        sortOrder
        isSubTopic
        displayIcon {
          url
        }
      }
    }
  }
`;

export const GET_CMS_COURSE = `
  query getCMSCourse($id: ID!, $drafts: Boolean, $cacheKey: Int) {
    cmsCourse(id: $id, drafts: $drafts, cacheKey: $cacheKey) {      
      id
      image {
        alt
        url
      }
      productPlan {
        code
      }
      instructionalLevel
      climbs {
        id
        image {
          url
        }
        shortDescription
        longDescription
        ladders {
          id
          order
          estimatedTime
          experiencePoints
          name
        }
        topics {
          id
          name
          sortOrder
          isSubTopic
          displayIcon {
            url
          }
        }
      longDescription
      name
      shortDescription
      topics {
        id
        name
        sortOrder
        isSubTopic
        displayIcon {
          url
        }
      }
    }
  }
`;

export const GET_CMS_COURSES = `
  query getCourses($drafts: Boolean, $cacheKey: Int) {
    cmsCourses(drafts: $drafts, cacheKey: $cacheKey) {
      id
      image {
        alt
        url
      }
      productPlan {
        code
      }
      instructionalLevel
      climbs {
        id
        name
        learnosityTag
        image {
          url
        }
        shortDescription
        longDescription
        ladders {
          id
          order
          estimatedTime
          experiencePoints
          name
        }
        topics {
          id
          name
          sortOrder
          isSubTopic
          displayIcon {
            url
          }
        }
      }
      order
      longDescription
      name
      estimatedCourseTime
      shortDescription
      topics {
        id
        name
        sortOrder
        isSubTopic
        displayIcon {
          url
        }
      }
    }
  }
`;

export const COMPLETE_BUILDING_BLOCK_ACTIVITY = `
  mutation createOrUpdateBuildingBlockActivity($input: BuildingBlockActivityInput!) {
    createOrUpdateBuildingBlockActivity(input: $input) {
      id
      parentID
      shardID
      categoryID
      activityID
      userActivityDescription
      userActivityDuration
      sentiments {
        connectorId
        sentiment
        reason
      }
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_BUILDING_BLOCK_ACTIVITY = `
  mutation deleteBuildingBlockActivity($input: DeleteBuildingBlockActivityInput!) {
    deleteBuildingBlockActivity(input: $input) {
      success
      message
    }
  }
`;

export const GET_HAT_STATUSES = `
  query GetHatStatuses {
    getHatSaved
    getHatFavorites
    getHatHeardOfs {
      hatId
      heardOf
    }
    getHatSentiments {
      hatId
      sentiment
    }
  }
`;

export const GET_CMS_PATHWAYS = `
  query getPathways($drafts: Boolean, $cacheKey: Int) {
    cmsPathways(drafts: $drafts, cacheKey: $cacheKey) {
      id
      name
      introText
      productPlan {
        code
      }
      displayImage {
        alt
        url
      }
      content {    
        contentType
        blockType
        id
        activity {
          id
        }
        ladder {
          id
        }
        video {
          id
        }      
      }
      careerCluster {
        id
        name
        icon {
          url
        }
        displayImage {
          url
          alt
        }
        introText
        colorTheme
        riasecScores {
          realistic
          investigative
          artistic
          social
          enterprising
          conventional
        }
        content {
          blockType
          blockName          
          activity {
            id
            name
          }
          video {
            id
            videoId
            blockName
            blockType
            video {
              caption
              url
              tracks {
                locale
                url
              }
            }
          }
          ladder {
            id
            name
          }
          contentType
          slides {
            blockType
            video {
            id
            videoId
            blockName
            blockType
            video {
                caption
                url
                 tracks {
                  locale
                  url
                }
              }
            }
            content
            image {
              alt
              url
            }
            caption
          }
        }
      }

      content {
        id
        blockType
        blockName        
        video {
            id
            videoId
            blockName
            blockType
            video {
              caption
              url
               tracks {
                locale
                url
              }
            }
          }
        activity {
          id
        }
        ladder {
          id
          name
        }
        contentType
        slides {
          id
          blockType
          video {
            id
            videoId
            blockName
            blockType
            video {
              id
              caption
              url
              tracks {
                locale
                url
              }
            }
          }
          content
          image {
            alt
            url
          }
          caption
        }
      }
      updatedAt
      createdAt
    }
  }
`;

// content {
//   id
//   blockType
//   blockName
//   videoType
//   video
//   ladderType
//   ladder
//   contentType
//   slides {
//     id
//     blockType
//     video {
//       id
//       videoId
//       blockName
//       blockType
//       video: {
//         id
//         caption
//         streamingUrl
//         thumbnailUrl
//         url
//         filename
//         mimeType
//         filesize
//     }
//     content
//     image {
//       url
//       alt
//     }
//     caption
//   }
// }

export const GET_CMS_TOPICS = `
  query getTopics($drafts: Boolean, $cacheKey: Int) {
    cmsTopics(drafts: $drafts, cacheKey: $cacheKey) {
      id
      name
      isSubTopic
      sortOrder
      displayIcon {
        url
      }
    }
  }
`;

export const GET_CMS_REGIONS = `
  query getRegions($drafts: Boolean, $cacheKey: Int) {
    cmsRegions(drafts: $drafts, cacheKey: $cacheKey) {
      id
      name
      type
      code
      active
      description
    }
  }
`;

export const GET_CMS_LADDERS_CONTENT = `
  query getLadders($drafts: Boolean, $cacheKey: Int) {
    cmsLadders(drafts: $drafts, cacheKey: $cacheKey) {
      id
      ladderType
      assessments {
        id
        assessment
        productPlan {
          code
        }
      }
      image {
        url
        alt
      }
      topics {
        name
        isSubTopic
        sortOrder
        displayIcon {
          url
        }
      }
      estimatedTime
      experiencePoints
      itemCount
      id
      instructionalLevel
      name
      shortDescription
    }
  }
`;

export const GET_CMS_LADDER_CONTENT = `
  query getLadderContent($id: ID!, $drafts: Boolean, $cacheKey: Int) {
    cmsLadder(id: $id, drafts: $drafts, cacheKey: $cacheKey) {
      id
      ladderType
      endScreenDescription
      assessments {
        id
        assessment
        active
      }
      image {
        url
        alt
      }
      topics {
        name
        isSubTopic
        displayIcon {
          url
        }
      }
      estimatedTime
      experiencePoints
      itemCount
      id
      instructionalLevel
      name
      shortDescription
    }
  }
`;

export const GET_HAT_ASSESSMENT_STATUSES = `
  query getHatAssessmentStatuses($hatId: ID!) {
    getHatAssessmentStatuses(hatId: $hatId) {
      completedAt
      hatId
      assessmentType
      learnositySessionId
      score
      maxScore
      status
    }
  }
`;

export const GET_HAT_ASSESSMENT_STATUS = `
  query getHatAssessmentStatus($assessmentType: String!, $hatId: ID!) {
    getHatAssessmentStatus(assessmentType: $assessmentType, hatId: $hatId) {
      hatId
      assessmentType
      completedAt
      createdAt
      learnositySessionId
      score
      maxScore
      status
    }
  }
`;

export const SET_HAT_ASSESSMENT_STATUS = `
  mutation setHatAssessmentStatus(
    $assessmentType: String!
    $hatId: ID!
    $status: String!
    $score: Float!
    $maxScore: Float!
  ) {
    setHatAssessmentStatus(
      assessmentType: $assessmentType
      hatId: $hatId
      status: $status
      score: $score
      maxScore: $maxScore
    ) {
      hatId
      assessmentType
      status
      score
      maxScore
      createdAt
      completedAt
      learnositySessionId
    }
  }
`;

export const GET_CMS_HAT_THEMES = `
  query getCMSHatThemes($drafts: Boolean, $cacheKey: Int) {
    cmsHatThemes(drafts: $drafts, cacheKey: $cacheKey) {
      id
      name
      description
      areaLabel
      color      
      themeType
      productPlan {
        code
        name
      }
      icon {
        url
      }
      relatedHats
    }
  }
`;
export const GET_CMS_HAT_CONTENT = `
  query GetCMSHatContent($hatId: ID!, $msaId: ID!, $stateId: ID!, $drafts: Boolean, $cacheKey: Int) {
    cmsHatsRegions(hatId: $hatId, msaId: $msaId, stateId: $stateId, drafts: $drafts, cacheKey: $cacheKey) {
      id      
      region {
        id
        name
        code
        type
      }
      payRange {
        mean
        seventyFifthPercentile
        twentyFifthPercentile
      }
      demand
      skills {
        percentage
        skill {
          name
          skillType          
        }
      }
      hat {
        themes        
        alsoLike {
          relatedHat {
            id
          }
        }
        skills {
          id
          name
          description
          percentage
          displayImage {
            url
          }
        }
        workActivities {
          id
          name
          description
          score
          displayImage {
            url
          }
        }
        perks {
          id
          name
        }
        quirks {
          id
          name
        }
        themes
        hatVideos {
          videoDescription
          hatVideo {
            video {
              streamingUrl
              thumbnailUrl
              caption
               tracks {
                locale
                url
              }
            }
            videoId
            blockType
          }
        }
        assessments {
          active
          assessment
          assessmentType
          experience
          productPlan {
            code
          }
        }
        careerArea {
          name
          id
        }
        careerCluster {
          icon {
            url
          }
          name
        }
        contextSummary {
          name
          id
          heading
          description
        }
        displayImage {
          alt
          sizes {
            hatPage {
              url
            }
          }
        }
        hatCardImage {
          alt
          smallSquare
          mediumSquare
          smallCard
          mediumCard
          largeCard
          hero
        }
        displayName
        id
        onTheJobTraining {
          name
        }
        preparationLevel
        workValues {
          workingConditions        
          support
          relationships
          recognition
          independence
          achievement
        }
        riasecScores {
          artistic
          conventional
          enterprising
          investigative
          realistic
          social
        }
        shortDescription
        tagline
        typicalExperience {
          percentage
          experience {
            category
            description
            label
          }
        }
      }
    }
  }
`;

export const GET_MS_CMS_HAT_INDEX = `
  query GetCMSHatIndex($drafts: Boolean, $cacheKey: Int) {
    cmsHatsIndex(drafts: $drafts, cacheKey: $cacheKey) {
      id
      displayName
      tagline
      productPlans
      msShortDescription
      msPathway
      msTagline
      previewAudio      
      msCareerCluster 
      careerArea {
          name
          id
      }
      riasecScores {
        social
        realistic
        investigative
        enterprising
        conventional
        artistic
      }
      displayImage {
        alt
        sizes {
          hatCard {
            url
          }
        }
      }
    }
  }
`;

export const GET_CMS_HAT_INDEX = `
  query GetCMSHatIndex($drafts: Boolean, $cacheKey: Int) {
    cmsHatsIndex(drafts: $drafts, cacheKey: $cacheKey) {
      id
      displayName
      tagline
      productPlans
      msShortDescription
      msPathway
      msTagline
      previewAudio
      careerArea {
        name
      }        
      careerCluster {
        name
        icon {
          url
        }
        id
      }
      riasecScores {
        social
        realistic
        investigative
        enterprising
        conventional
        artistic
      }
      displayImage {
        alt
        sizes {
          hatCard {
            url
          }
        }
      }
    }
  }
`;

export const GET_HAT_CARD_IMAGES = `
  query GetHatCardImages($hatIds: [ID!]!, $cacheKey: Int) {
    cmsHatCardImages(hatIds: $hatIds, cacheKey: $cacheKey) {
      id
      hatCardImage {
        alt
        smallSquare
        mediumSquare
      }
    }
  }
`;

export const GET_HAT_SENTIMENTS = `
  query getHatSentiments {
    getHatSentiments {
      hatId
      sentiment
    }
  }
`;

export const SET_HAT_SENTIMENT_STATUS = `
  mutation setHatSentimentStatus($hatId: ID!, $sentiment: HatSentiment!) {
    setHatSentimentStatus(hatId: $hatId, sentiment: $sentiment)
  }
`;

export const GET_HAT_STATISTICS = `
  query getHatStatistics {
    getHatStatistics {
      hatsFavorited
      hatsSaved
      hatsLiked
      hatsDisliked
      hatsNotForMe
      hatsLoved
      hatsHeardOf
      hatsNotHeardOf
    }
  }
`;

export const GET_GENERIC_USER_DATA = `
  query getGenericUserByEmail($email: String!) {
    getUserByEmail(email: $email) {
      id
      lastName
      firstName
      username
      shardID
      sub
      parentID
    }
  }
`;

export const GET_CLIMBER_DATA = `
  query getClimberBySub($sub: String!) {
    getClimberBySub(sub: $sub) {
      id
      lastName
      firstName
      username
      xp
      shardID
      sub
      parentID
      path
      receivedSurvey
      contractTTL
      ladderProgress {
        highScore
        maxScore
        ladderId
        learnosityReference
        learnositySessionId
        externalRegistrationId
        numberOfSessions
        overallStatus
      }
      profileChoices {
        avatar
        birthMonth
        birthYear
        catchphrase
        goal
        careerStage
        careerConfidence
        topThemes
      }
      facets {
        ladderId
        facets {
          facet
          score
        }
      }     
    }
  }
`;

export const GET_MY_USER_RECORDS = `
    query GetMyUserRecords {
      getMyUserRecords {
        applicationOnlineID
        canAddPeers
        contractTTL
        preferredID
        dob
        email
        careerPlan {
          lastUpdatedAt
          planStatus
          pathwayId
          careerPlanId
          approvedAt
        }
        coursePlan {
          lastUpdatedAt
          planStatus
          pathwayId
          coursePlanId
          programId
          programName
          districtPathwayId
          districtPathwayName
          cteCourseSequence {
            id
            name
          }
          approvedAt
          createdAt
        }
        facets {
          ladderId
          facets {
            facet
            score
          }
        }
        firstName
        id
        ladderProgress {
          completeDate
          ladderId
          learnosityReference
          highScore
          learnositySessionId
          externalRegistrationId
          maxScore
          numberOfSessions
          overallStatus
        }
        lastName
        lastRepairedDate
        middleName
        parentID
        path
        profileChoices {
          avatar
          birthMonth
          birthYear
          topThemes
          goal
          catchphrase
          careerStage
          careerConfidence
        }
        xp
        username
        sub
        shardID
        receivedSurvey
        activeDistrictId
        helpDesk
      }
    }
  `;

export const GET_CLIMBER_BY_ID = `
  query getClimberById($id: ID!) {
    getClimberById(id: $id) {
      id
      lastName
      firstName
      username
      xp
      shardID
      email
      sub
      parentID
      path
      preferredID
      receivedSurvey
      ladderProgress {
        highScore
        maxScore
        ladderId
        learnosityReference
        learnositySessionId
        externalRegistrationId
        numberOfSessions
        overallStatus
      }
      profileChoices {
        avatar
        birthMonth
        birthYear
        catchphrase
        goal
        careerStage
        careerConfidence
        topThemes
      }
      facets {
        ladderId
        facets {
          facet
          score
        }
      }
      careerPlan {
        lastUpdatedAt
        planStatus
        pathwayId
        careerPlanId
        approvedAt
      }
      coursePlan {
        lastUpdatedAt
        planStatus
        pathwayId
        coursePlanId
        programId
        programName
        districtPathwayId
        districtPathwayName
        cteCourseSequence {
          id
          name
        }
        approvedAt
        createdAt
      }

    }
  }
`;

export const GET_CLIMBER_BY_YEPSID_DOB = `
  query getClimberByDobYeps($dob: String!, $yepsID: String!) {
    getClimberByDobYeps(dob: $dob, yepsID: $yepsID ) {
      id
      lastName
      firstName
      username
      sub
      path
    }
  }
`;

export const GET_SCHOOL_STAFF_DATA = `
  query getSchoolStaffBySub($sub: String!) {
    getSchoolStaffBySub(sub: $sub) {
      id
      lastName
      firstName
      username
      shardID
      sub
      parentID
      path
      canAddPeers
    }
  }
`;

export const GET_SCHOOL_STAFF_DATA_BY_ID = `
  query getSchoolStaffById($id: ID!) {
    getSchoolStaffById(id: $id) {
      id
      lastName
      firstName
      username
      shardID
      sub
      parentID
      path
      canAddPeers
    }
  }
`;

export const GET_DISTRICT_ADMIN_DATA_BY_ID = `
  query getDistrictAdminById($id: ID!) {
    getDistrictAdminById(id: $id) {
      id
      lastName
      firstName
      username
      shardID
      sub
      parentID
      path
      canAddPeers
    }
  }
`;

export const GET_SCHOOL_DATA = `
  query getSchoolById($id: ID!) {
    getSchoolById(id: $id) {
      id
      parentID
      path
      shardID
      schoolName
      contractTTL
    }
  }
`;

export const GET_DISTRICT_DATA = `
  query getDistrictById($id: ID!) {
    getDistrictById(id: $id) {
      contractTTL
      districtName
      loginMethod
      id
      parentID
      path
      shardID
      syncID
      centralizedAssignments
      country
      state
      msa
      nomenclature
      worksiteRequirements
      accessToken
      shouldSync
      checkinStartMonth
      checkinStartDay
      checkinEndMonth
      checkinEndDay
    }
  }
`;

export const GET_SUPERVISORY_UNION_DATA = `
  query getSupervisoryUnionById($id: ID!) {
    getSupervisoryUnionById(id: $id) {
      unionName
      id
      parentID
      path
    }
  }
`;

export const GET_TEACHER_DATA = `
  query getTeacherBySub($sub: ID!) {
    getTeacherBySub(sub: $sub) {
      id
      lastName
      firstName
      username
      shardID
      sub
      parentID
      path
    }
  }
`;

export const GET_TEACHER_DATA_BY_ID = `
  query getTeacherById($id: ID!) {
    getTeacherById(id: $id) {
      id
      lastName
      firstName
      username
      shardID
      sub
      parentID
      path
    }
  }
`;

export const GET_SUPERADMIN_DATA_BY_ID = `
  query getSuperAdminById($id: ID!) {
    getSuperAdminById(id: $id) {
      id
      lastName
      firstName
      username
      sub
      parentID
      path
      activeDistrictId
    }
  }
`;

export const SET_ACTIVE_DISTRICT = `
  mutation setActiveDistrict($districtId: String) {
    setActiveDistrict(districtId: $districtId) {
      id
      activeDistrictId
      shardID
    }
  }
`;

export const GET_SECTION_DATA = `
  query getSectionData($id: ID!) {
    getSectionById(id: $id) {
      id
      parentID
      path
      shardID
      careerClimbs
      sectionName
      schoolName
      coachSubscription
      climberSubscription
      contractTTL
      program
      serviceOption
      sessionId
    }
  }
`;

export const GET_SECTIONS_FOR_SCHOOL = `
  query getSectionsForSchool($parentID: String) {
    getSectionsForSchool(parentID: $parentID) {
      id
      parentID
      path
      shardID
      sectionName
      sessionId
    }
  }
`;

export const GET_TEACHERS_FOR_SECTION = `
  query getTeachersForSection($parentID: String) {
    getTeachersForSection(parentID: $parentID) {
      id
      lastName
      firstName
      username
      shardID
      sub
      parentID
      path
      contractTTL
      email
    }
  }
`;

export const GET_SCHOOLSTAFF_FOR_SCHOOL = `
  query getSchoolStaffForSchool($parentID: String) {
    getSchoolStaffForSchool(parentID: $parentID) {
      canAddPeers
      contractTTL
      email
      firstName
      id
      lastName
      middleName
      parentID
      path
      shardID
      sub
      username
    }
  }
`;

export const GET_ADMIN_FOR_DISTRICT = `
  query getAdminsForDistrict($parentID: String) {
    getAdminsForDistrict(parentID: $parentID) {
      canAddPeers
      contractTTL
      email
      firstName
      id
      lastName
      parentID
      path
      shardID
      sub
      username
    }
  }
`;

export const GET_SCHOOLS_FOR_DISTRICT = `
  query getSchoolsForDistrct($parentID: String) {
    getSchoolsForDistrict(parentID: $parentID) {
      contractTTL
      id
      parentID
      path
      schoolName
      shardID
    }
  }
`;

export const GET_DISTRICTS_FOR_UNION = `
  query getDistrictsForUnion($parentID: String) {
    getDistrictsForUnion(parentID: $parentID) {
      id
      parentID
      path
      districtName
      shardID
    }
  }
`;

export const GET_SECTION_CLIMBERS_DATA = `
  query getSectionClimbersData($sectionID: String!, $nextToken: String, $limit: Int) {
    getClimbersBySectionId(sectionID: $sectionID, nextToken: $nextToken, limit: $limit) {
      climbers {
        id
        firstName
        lastName
        parentID
        path
        preferredID
        shardID
        shoutOutsReceivedCount
        email
        sub
        receivedSurvey
        ladderProgress {
          highScore
          maxScore
          ladderId
          learnosityReference
          learnositySessionId
          externalRegistrationId
          numberOfSessions
          overallStatus
        }
        profileChoices {
          avatar
          birthMonth
          birthYear
          catchphrase
          goal
          careerStage
          careerConfidence
          topThemes
        }
        dob
        applicationOnlineID
        worksite
        worksiteVisits {
          id
          visitDate
        }
        careerPlan {
          lastUpdatedAt
          planStatus
          pathwayId
          careerPlanId
          approvedAt
        }
        coursePlan {
          lastUpdatedAt
          planStatus
          pathwayId
          coursePlanId
          programId
          programName
          districtPathwayId
          districtPathwayName
          cteCourseSequence {
            id
            name
          }
          approvedAt
          createdAt
        }
        username
        xp
        contractTTL
        grades
      }
      nextToken
    }
  }
`;

export const GET_CLIMBERS_BY_SCHOOL = `
  query getClimbersBySchool($input: GetClimbersBySchoolInput!) {
    getClimbersBySchool(input: $input) {
      climbers {
        id
        firstName
        lastName
        parentID
        preferredID
        email
        username
        grades
        careerPlan {
          careerPlanId
          planStatus
          pathwayId
          lastUpdatedAt
          approvedAt
        }
        coursePlan {
          coursePlanId
          planStatus
          pathwayId
          lastUpdatedAt
          approvedAt
          createdAt
          programId
          programName
          districtPathwayId
          cteCourseSequence {
            id
            name
          }
        }
      }
      nextToken
    }
  }
`;

export const UPDATE_CLIMBER_XP = `
  mutation updateClimberXP($input: UpdateClimberInput!) {
    updateClimberXP(input: $input) {
      xp
    }
  }
`;

export const UPDATE_DISTRICT = `
  mutation updateDistrict($input: updateDistrictInput!) {
    updateDistrict(input: $input) {
      contractTTL
      districtName
      loginMethod
      id
      parentID
      path
      shardID
      syncID
      centralizedAssignments
      country
      state
      msa
      nomenclature
      worksiteRequirements
      accessToken
      shouldSync
      checkinStartMonth
      checkinStartDay
      checkinEndMonth
      checkinEndDay
    }
  }
`;

export const UPDATE_CLIMBER_NAME = `
  mutation updateClimberName($input: UpdateClimberInput!) {
    updateClimberName(input: $input) {
      id
      path
      firstName
      lastName
    }
  }
`;

export const ADD_TO_SECTION = `
  mutation addToSection($input: AddToSectionInput!) {
    addToSection(input: $input) {
      id
      path
      firstName
      lastName
    }
  }
`;

export const UPDATE_CLIMBER_RECEIVED_SURVEY = `
  mutation updateClimberReceivedSurvey($input: UpdateClimberInput!) {
    updateClimberReceivedSurvey(input: $input) {
      id
      receivedSurvey
    }
  }
`;

export const REPAIR_USER_SUB = `
  mutation repairClimberSub($input: RepairClimberSubInput!) {
    repairClimberSub(input: $input) {
      id
      path
      sub
      lastRepairedDate
    }
  }
`;

export const INVOKE_LEARNOSITY_LAMBDA_QUERY = `
  query invokeLearnosityLambda($payload: InvokeLearnosityLambdaInput!) {
    invokeLearnosityLambda(payload: $payload)
  }
`;

export const INVOKE_PASSPHRASE_GENERATOR_LAMBDA_QUERY = `
  query invokePassphraseGeneratorLambda(
    $payload: PassphraseGeneratorLambdaInput!
  ) {
    invokePassphraseGeneratorLambda(payload: $payload)
  }
`;

export const INVOKE_PASSWORD_RESET_LAMBDA_QUERY = `
  query invokePasswordResetLambda($payload: PasswordResetLambdaInput!) {
    invokePasswordResetLambda(payload: $payload)
  }
`;

export const INVOKE_BATCH_UPDATE_USER_SUB_QUERY = `
  query invokeBatchUpdateUserSubLambda($payload: BatchUpdateUserSubInput!) {
    invokeBatchUpdateUserSubLambda(payload: $payload)
  }
`;

export const INVOKE_GROUP_ASSIGN_LAMBDA_QUERY = `
  query invokeGroupAssignLambda($payload: GroupAssignLambdaInput!) {
    invokeGroupAssignLambda(payload: $payload)
  }
`;

export const INVOKE_EDLINK_TOKEN_MAPPER_LAMBDA_QUERY = `
  query invokeEdlinkTokenMapperLambda($payload: EdlinkTokenMapperLambdaInput!) {
    invokeEdlinkTokenMapperLambda(payload: $payload)
  }
`;

export const GET_CAREER_CLIMBS_BY_ID_AND_PATH = `
  query getCareerClimbsByIdAndPath($input: UpdateCareerClimbDueByInput!) {
    getCareerClimbsByIdAndPath(input: $input) {
      assignedStart
      dueBy
      startDate
      completeDate
      id
      learnosityTag
      parentID
      path
      shardID
      contractTTL
      assigner {
        firstName
        lastName
        userID
      }
    }
  }
`;

export const GET_CAREER_CLIMBS = `
  query getCareerClimbsByShardId($shardID: String, $userPath: String) {
    getCareerClimbsByShardId(shardID: $shardID, userPath: $userPath) {
      assignedStart
      dueBy
      startDate
      completeDate
      id
      learnosityTag
      parentID
      path
      shardID
      contractTTL
      assigner {
        firstName
        lastName
        userID
      }
    }
  }
`;

export const GET_CAREER_CLIMBS_BY_PARENT_ID = `
  query getCareerClimbsByParentId($parentID: String!, $shardID: String!) {
    getCareerClimbsByParentId(parentID: $parentID, shardID: $shardID) {
      assignedStart
      completeDate
      dueBy
      id
      learnosityTag
      parentID
      startDate
      path
      shardID
      contractTTL
      assigner {
        firstName
        lastName
        userID
      }
    }
  }
`;

export const GET_MY_CAREER_CLIMBS = `
  query getMyCareerClimbs {
    getMyCareerClimbs {
      assignedStart
      completeDate
      dueBy
      id
      learnosityTag
      parentID
      startDate
      path
      shardID
      contractTTL
      assigner {
        firstName
        lastName
        userID
      }
    }
  }
`;

// TODO - get rid of this in favor of the more generic GET_CAREER_CLIMBS_BY_PARENT_ID
export const GET_CAREER_CLIMBS_BY_SECTION_ID = `
  query getCareerClimbsBySectionId($sectionID: String!) {
    getCareerClimbsBySectionId(sectionID: $sectionID) {
      assignedStart
      completeDate
      dueBy
      id
      learnosityTag
      parentID
      path
      shardID
      contractTTL
      assigner {
        firstName
        lastName
        userID
      }
    }
  }
`;

export const START_CAREER_CLIMB = `
  mutation createCareerClimbProgress($input: CareerClimbProgressInput) {
    createCareerClimbProgress(input: $input) {
      assignedStart
      dueBy
      id
      learnosityTag
      parentID
      path
      shardID
      startDate
      completeDate
      assigner {
        firstName
        lastName
        userID
      }
    }
  }
`;

export const GET_ACTIVITY_COMPLETION_BY_PARENT_ID = `
  query getActivityCompletionByParentId($parentID: String!, $id: ID!) {
    getActivityCompletionByParentId(parentID: $parentID, id: $id) {
      id
      parentID
      path
      responses {
        promptId
        responseId
      }
      pathwayScores {
        pathwayId
        score
      }
      connectorScores {
        connectorId
        score
      }
      timestamp
    }
  }
`;

export const COMPLETE_CAREER_CLIMB = `
  mutation updateCareerClimbProgress($input: UpdateCareerClimbProgressInput!, $metadata: AWSJSON!, $whatId: String!) {
    
  updateCareerClimbProgress(input: $input) {
      assignedStart
      dueBy
      id
      learnosityTag
      parentID
      path
      shardID
      startDate
      completeDate
      assigner {
        firstName
        lastName
        userID
      }
    }

    logEvent(input: {
      whatId: $whatId,
      eventType: "climb-completion",
      metadata: $metadata
    })
  }
`;

export const ASSIGN_CAREER_CLIMB = `
  mutation createOrUpdateCareerClimb($input: CareerClimbProgressInput) {
    createOrUpdateCareerClimb(input: $input) {
      assignedStart
      dueBy
      id
      learnosityTag
      parentID
      path
      shardID
      startDate
      completeDate
      assigner {
        firstName
        lastName
        userID
      }
    }
  }
`;

export const SET_SAVED_STATUS = `
  mutation setSavedStatus($hatId: ID!, $saved: Boolean!) {
    setSavedStatus(hatId: $hatId, saved: $saved)
  }
`;

export const SET_FAVORITE_STATUS = `
  mutation setFavoriteStatus($hatId: ID!, $favorite: Boolean!) {
    setFavoriteStatus(hatId: $hatId, favorite: $favorite)
  }
`;

export const SET_HEARD_OF_STATUS = `
  mutation setHeardOfHatStatus($hatId: ID!, $heardOf: Boolean!) {
    setHeardOfHatStatus(hatId: $hatId, heardOf: $heardOf)
  }
`;

export const SEND_MESSAGE = `
  mutation createOrUpdateMessage($input: MessageInput) {
    createOrUpdateMessage(input: $input) {
      id
    }
  }
`;

// WorkSites
export const CREATE_OR_UPDATE_WORKSITE = `
  mutation createOrUpdateWorkSite($input: WorkSiteInput) {
    createOrUpdateWorkSite(input: $input) {
      id
      parentID
      shardID
      path
      companyName
      address
      supervisor
      phoneNumber
      createdAt
      updatedAt
      createdBy
      lastModifiedBy
    }
  }
`;

export const GET_WORKSITES_FOR_DISTRICT = `
  query getWorkSitesForDistrict($parentID: String) {
    getWorkSitesForDistrict(parentID: $parentID) {
      id
      parentID
      shardID
      path
      companyName
      address
      supervisor
      phoneNumber
      createdAt
      updatedAt
      createdBy
      lastModifiedBy
    }
  }
`;

export const DELETE_CAREER_CLIMB = `
  mutation deleteCareerClimbs($input: DeleteItemInput!) {
    deleteCareerClimbs(input: $input) {
      success
    }
  }
`;

export const DELETE_ITEM = `
  mutation deleteItem($input: DeleteItemInput!) {
    deleteItem(input: $input) {
      success
    }
  }
`;

export const UNDO_DELETE = `
  mutation UndoDelete($input: UndoDeleteInput!) {
    undoDelete(input: $input)
  }
`;

export const DELETE_USER_ROW = `
  mutation deleteUserRow($id: ID!, $path: String!) {
    deleteUserRow(id: $id, path: $path) {
      success
    }
  }
`;

export const UPDATE_TEACHER = `
  mutation createOrUpdateTeacher($input: TeacherInput) {
    createOrUpdateTeacher(input: $input) {
      id
      sub
      parentID
      path
      shardID
      username
      firstName
      lastName
      contractTTL
      email
    }
  }
`;

export const UPDATE_SCHOOL_STAFF = `
  mutation createOrUpdateSchoolStaff($input: SchoolStaffInput) {
    createOrUpdateSchoolStaff(input: $input) {
      id
      sub
      parentID
      path
      shardID
      username
      firstName
      lastName
      contractTTL
      email
    }
  }
`;

export const UPDATE_CLIMBER = `
  mutation createOrUpdateClimber($input: ClimberInput) {
    createOrUpdateClimber(input: $input) {
      id
      sub
      parentID
      path
      shardID
      username
      firstName
      lastName
      contractTTL
      xp
      receivedSurvey      
    }
  }
`;

export const UPDATE_CAREER_CLIMB_ASSIGNMENT_DETAILS = `
  mutation updateCareerClimbAssignmentDetails(
    $input: UpdateCareerClimbAssignmentInput
  ) {
    updateCareerClimbAssignmentDetails(input: $input)
  }
`;

export const GET_MESSAGES = `
  query getMessages($subscriptionID: String!) {
    getMessages(subscriptionID: $subscriptionID) {
      careerClimbID
      careerPlanId
      learnosityTag
      content
      id
      parentID
      image
      path
      subscriptionID
      type
      timestamp
      readBy
      sender {
        firstName
        lastName
        userID
      }
    }
  }
`;

export const MARK_MESSAGE_AS_READ = `
  mutation markMessageAsRead(
    $messageID: ID!
    $userID: String!
    $path: String!
    $contractTTL: Int!
  ) {
    markMessageAsRead(messageID: $messageID, userID: $userID, path: $path, contractTTL: $contractTTL) {
      id
    }
  }
`;

export const INVOKE_MANUAL_ROSTERING = `
  query invokeManualRosteringLambda($payload: ManualRosteringLambdaInput!) {
    invokeManualRosteringLambda(payload: $payload)
  }
`;

export const INVOKE_EMAIL_CHECKER = `
  query invokeEmailCheckerLambda($payload: EmailCheckerLambdaInput!) {
    invokeEmailCheckerLambda(payload: $payload)
  }
`;

export const INVOKE_CREATE_RUSTICI_REGISTRATION = `
  query invokeCreateRusticiRegistrationLambda($payload: InvokeCreateRusticiRegistrationLambdaInput!) {
    invokeCreateRusticiRegistrationLambda(payload: $payload)
  }
`;

export const INVOKE_CREATE_RUSTICI_LAUNCH_LINK = `
  query invokeCreateRusticiLaunchLinkLambda($payload: InvokeCreateRusticiLaunchLinkLambdaInput!) {
    invokeCreateRusticiLaunchLinkLambda(payload: $payload)
  }
`;

export const UPDATE_CLIMBERS_PROFILE_CHOICES = `
  mutation updateClimbersProfileChoices(
    $profileChoices: ProfileChoicesInput!
  ) {
    updateClimbersProfileChoices(
      profileChoices: $profileChoices
    ) {
      id
    }
  }
`;

export const GET_EMBEDDABLE_REPORT_SIGNATURE = `
  query getEmbeddableReportSignature($input: EmbeddableReportSignatureInput!) {
    getEmbeddableReportSignature(input: $input) {
      token
      Status
      Error
    }
  }`;

export const GET_REPORT_SIGNATURE = `
  query getReportSignature($input: ReportSignatureInput!) {
    getReportSignature(input: $input) {
      EmbedUrl
      Status
      RequestId
      AnonymousUserArn
    }
  }
`;

export const LOG_EVENT = `
  mutation logEvent($input: LogEventInput!) {
    logEvent(input: $input)
  }
`;

export const UPLOAD_LOGO_URL = `
  mutation createUploadLogoUrl($districtID: String!, $fileType: String!) {
    createUploadLogoUrl(districtID: $districtID, fileType: $fileType)
}`;

export const GET_CMS_ACTIVITY = `
  query getCMSActivity($id: ID!, $drafts: Boolean, $cacheKey: Int) {
    cmsActivity(id: $id, drafts: $drafts, cacheKey: $cacheKey) {
      id
      name
      description
      displayImage {
        url
        alt
      }
      content {
        blockType
        id
        shortStem
        optionA
        optionB
        feedbackA
        feedbackB
        correctAnswer
        image {
          url
        }
        responses {          
          buildingBlocks {
            score
            buildingBlock {
              id
            }
          }
          pathways {
            pathway {
              id
            }
            score
          }
          responseImage {
            url
            alt
          }
          id
          responseLabel
          responseType
        }
        stem
      }
    }
  }
`;

export const GET_CMS_BUILDING_BLOCK_ACTIVITIES = `
  query getCMSBuildingBlockActivities($cacheKey: Int) {
    cmsBuildingBlockActivities(cacheKey: $cacheKey) {
      id
      name
      category {
        id
        name
        icon {
          url
        } 
      }
      buildingBlocks
      updatedAt
      createdAt
    }
  }
`;

export const COMPLETE_ACTIVITY = `
  mutation completeActivity($input: ActivityCompletionInput!) {
    completeActivity(input: $input) {
      id
    }
  }
`;

export const GET_CMS_SHOUT_OUT_CONNECTORS = `
  query getCMSShoutOutConnectors($drafts: Boolean, $cacheKey: Int) {
    cmsBuildingBlocks(
      drafts: $drafts
      cacheKey: $cacheKey
      shoutOutEnabled: true
    ) {
      id
      name
      dropdownDisplayText
      icon {
        url
      }
      description
      teacherDescription
      displayOrder
      shoutOutCategory
      alsoKnownAs
    }
  }
`;

export const GET_CMS_BUILDING_BLOCKS = `
  query getCMSBuildingBlocks($drafts: Boolean, $cacheKey: Int) {
    cmsBuildingBlocks(drafts: $drafts, cacheKey: $cacheKey) {
      id
      name
      dropdownDisplayText
      category {
        id
        name
      }
      description
      pathways {
        weight
        pathwayId
      }
      hats {
        weight
        hatId
      }
      updatedAt
      createdAt
}}`;
// Sentiment Queries
export const GET_CONNECTOR_SENTIMENTS = `
  query getConnectorSentiments {
    getConnectorSentiments {
      connectorId
      sentiment
      reason
      createdAt
      updatedAt
    }
  }
`;

export const GET_PATHWAY_SENTIMENTS = `
  query getPathwaySentiments {
    getPathwaySentiments {
      pathwayId
      sentiment
      reason
      createdAt
      updatedAt
    }
  }
`;

export const GET_PERKS_QUIRKS_SENTIMENTS = `
  query getPerksQuirksSentiments {
    getPerksQuirksSentiments {
      perksQuirksId
      sentiment
      reason
      createdAt
      updatedAt
    }
  }
`;

// Sentiment Mutations
export const RECORD_CONNECTOR_SENTIMENT = `
  mutation recordConnectorSentiment($input: ConnectorSentimentInput!) {
    recordConnectorSentiment(input: $input) {
      success
      message
    }
  }
`;

export const RECORD_PATHWAY_SENTIMENT = `
  mutation recordPathwaySentiment($input: PathwaySentimentInput!) {
    recordPathwaySentiment(input: $input) {
      success
      message
    }
  }
`;

export const RECORD_PERKS_QUIRKS_SENTIMENT = `
  mutation recordPerksQuirksSentiment($input: PerksQuirksSentimentInput!) {
    recordPerksQuirksSentiment(input: $input) {
      success
      message
    }
  }
`;

// Preference Queries
export const GET_CONNECTOR_PREFERENCES = `
  query getConnectorPreferences {
    getConnectorPreferences {
      connectorId
      score
      createdAt
      updatedAt
    }
  }
`;

export const GET_PATHWAY_PREFERENCES = `
  query getPathwayPreferences {
    getPathwayPreferences {
      pathwayId
      score
      
      createdAt
      updatedAt
    }
  }
`;

export const GET_BUILDING_BLOCK_ACTIVITIES_BY_PARENT_ID = `
  query GetBuildingBlockActivitiesByParentID($parentID: String!) {
    getBuildingBlockActivitiesByParentID(parentID: $parentID) {
      id
      categoryID
      activityID
      userActivityDescription
      userActivityDuration
      sentiments {
        connectorId
        sentiment
        reason
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_PATHWAY_CONTENT = `
  query GetPathwayContent($id: ID!) {
    cmsPathway(id: $id) {
      id
      name
      displayImage {
        alt
        url
      }
      content {
        blockType
        contentType
        id
        blockName        
        activity {
          name
          id
        }
        ladder {
          id
          name
        }
        video {
          id
          videoId
          blockName
          blockType
          video {
            caption            
            streamingUrl
            thumbnailUrl
            thumbnailOverride {
              alt
              url
            }
            tracks {
              locale
              url
            }
          }
        }
        description
        definitions {
          description
          example
          name
          displayImage {
            alt
            url
          }
        }
        displayImage {
          alt
          url
        }
        backgroundImage {
          alt
          url
        }
        slides {
          id
          blockType
          title
          description
          template
          video {
            id
            videoId
            blockName
            blockType
            video {
              id
              caption
              url
            }
          }
          content
          image {
            alt
            url
          }
          caption
        }
      }
      careerCluster {
        id
        name
        icon {
          url
        }
        displayImage {
          alt
          url
        }
        colorTheme
        riasecScores {
          social
          realistic
          investigative
          enterprising
          conventional
          artistic
        }
      }
      displayImage {
        alt
        url
      }
      introText
    }
  }
`;

export const GET_CAREER_CLUSTER = `
  query GetCareerCluster($id: ID!, $cacheKey: Int!) {
    cmsCareerCluster(id: $id, cacheKey: $cacheKey) {
      id
      introText
      content {
        activity {
          id
          name
        }
        audio {
          id
          transcript
          url
        }
        subheading
        heading
        title
        coverImage {
          alt
          url
        }
        interviewerName
        interviewerIcon {
          url
        }
        video {
          video {
            streamingUrl
            thumbnailUrl
            thumbnailOverride {
              alt
              url
            }
            caption
            tracks {
                locale
                url
              }
            }
          videoId          
        }
        slides {
          title
          description
          blockType
          template
          heading
          subheading
          video {
          id
          videoId
          blockName
          blockType
          video {
              caption
              url
            }
          }
          content
          image {
            alt
            url
          }
          caption
        }
        
        blockType
        contentType
        id
        description
        template
        title
        ladder {
          id
          name
        }
      }
      displayImage {
        alt
        url
      }
      icon {
        url
      }
      name
      colorTheme
      riasecScores {
        artistic
        conventional
        enterprising
        investigative
        realistic
        social
      }
    }
  }
`;

export const GET_CLUSTER_PATHWAY_COMPLETIONS = `
  query ClusterPathwayCompletions {
    getMyClusterCompletions {
      clusterId
      status
      statusUpdatedAt
      content {
        contentId
        details {
          blockType
          completionDate
          contentName
          contentType
          startDate
          status
        }
      }
    }
    getMyPathwayCompletions {
      content {
        contentId
        details {
          blockType
          completionDate
          contentType
          status
          startDate
          contentName
        }
      }
      pathwayId
    }
  }
`;

export const COMPLETE_CLUSTER_CONTENT = `
  mutation completeClusterContent(
    $input: MSCompleteClusterContentInput!
  ) {
    completeClusterContent(input: $input) {
      clusterId
    }
  }
`;

export const COMPLETE_PATHWAY_CONTENT = `
  mutation completePathwayContent(
    $input: MSCompletePathwayContentInput!
  ) {
    completePathwayContent(input: $input) {
      id
    }
  }
`;

export const SET_CLUSTER_STATUS = `
  mutation setClusterStatus(
    $input: MSSetClusterStatusInput!
  ) {
    setClusterStatus(input: $input) {
      id
      clusterId
      status
      statusUpdatedAt
    }
  }
`;

export const RESET_CURRENT_USER = `
  mutation resetCurrentUser($confirmation: String!, $options: ResetOptions) {
    resetCurrentUser(confirmation: $confirmation, options: $options) {
      success
      message
    }
  }
`;

export const GET_CMS_EDUCATOR_DOWNLOADS = `
  query getCMSEducatorDownloads($cacheKey: Int) {
    cmsEducatorDownloads(cacheKey: $cacheKey) {
      id
      name
      description
      downloads {
        id
        label
        url
        filename
        mimeType
        filesize
      }
      productPlan {
        id
        name
        code
      }
      resourceType {
        id
        name
        icon {
          url
        }
      }
      topic {
        id
        name
        isSubTopic
        displayIcon {
          url
        }
        sortOrder
      }
      careerClusters {
        id
        name
        icon {
          url
        }
        productPlan {
          code
        }
      }
      careerClimbs {
        id
        name
        image {
          url
        }
      }
      downloadTags
      updatedAt
      createdAt
    }
  }
`;

export const GET_NEXT_STEPS = `
  query getNextSteps($userPath: String!, $recentEvents: [RecentEventInput!], $productPlans: [String!]) {
    getNextSteps(userPath: $userPath, recentEvents: $recentEvents, productPlans: $productPlans) {
      id
      title
      stepType
      description
      strand
      url
      trackingType
      order
      status
      instructions
      displayImage 
      progress {
        current
        target
      }
    }
  }
`;

export const GET_NEXT_STEPS_DEBUG = `
  query getNextStepsDebug($userPath: String!, $productPlans: [String!]) {
    getNextStepsDebug(userPath: $userPath, productPlans: $productPlans) {
      availableStepsCount
      debug
      nextSteps {
        id
        description
        order
        status
        title
        url
        progress {
          current
          target
        }
      }
      userEventsCount
      existingIncompleteStepsCount
      userEvents {
        id
        eventType
        eventData
        timestamp
      }
      debugSteps {
        id
        title
        description
        url
        order
        strand
        status
        statusReason
        progress {
          current
          target
        }
        availabilityCheck
        completionCheck
      }
    }
  }
`;

export const UPDATE_NEXT_STEP_STATUS = `
  mutation updateNextStepStatus($input: UpdateNextStepStatusInput!) {
    updateNextStepStatus(input: $input) {
      success
      message
    }
  }
`;

export const GET_CMS_VIDEO = `
  query getCMSVideo($id: ID!, $drafts: Boolean, $cacheKey: Int) {
    cmsVideo(id: $id, drafts: $drafts, cacheKey: $cacheKey) {
      id
      caption
      streamingUrl
      thumbnailUrl
      mp4Url
      url
      filename
      mimeType
      filesize
      width
      height
      tracks {
        id
        locale
        url
      }
      updatedAt
      createdAt
    }
  }
`;

export const GET_CMS_CAREER_PLAN_NEXT_STEPS = `
  query getCMSCareerPlanNextSteps($drafts: Boolean, $cacheKey: Int) {
    cmsCareerPlanNextSteps(drafts: $drafts, cacheKey: $cacheKey) {
      body      
      id
      pathways {
        id
      }
      educationOptions {
        educationId
      }
      type
      category
      buildingBlock {
        name
        icon {
          url
        }
        description
      }
    }
  }
`;

export const GET_CMS_HAT_CONTENT_MS = `
  query GetCMSHatContentMS($hatId: ID!, $msaId: ID!, $stateId: ID!, $drafts: Boolean, $cacheKey: Int) {
    cmsHatsRegions(hatId: $hatId, msaId: $msaId, stateId: $stateId, drafts: $drafts, cacheKey: $cacheKey) {
      id      
      region {
        id
        name
        code
        type
      }
      payRange {
        mean
        seventyFifthPercentile
        twentyFifthPercentile
      }
      demand
      skills {
        percentage
        skill {
          name
          skillType
          powerskill
          powerskillLabel
        }
      }
      hat {
        alsoLike {
          relatedHat {
            id
          }
        }
        hatVideos {
          videoDescription
          hatVideo {
            video {
              streamingUrl
              thumbnailUrl
              caption
               tracks {
                locale
                url
              }
            }
            videoId
            blockType
          }
        }
        assessments {
          active
          assessment
          assessmentType
          experience
          productPlan {
            code
          }
        }
        contextSummary {
          name
          id
          heading
          description
        }
        displayImage {
          alt
          sizes {
            hatPage {
              url
            }
          }
        }
        hatCardImage {
          alt
          smallSquare
          mediumSquare
          smallCard
          mediumCard
          largeCard
          hero
        }

        backgroundImage {
          alt
          url          
        }

        jobGearDisplayImage {
          url
        }
        perksQuirksDisplayImage {
          url
        }

        displayName
        id
        onTheJobTraining {
          name
        }
        preparationLevel
        riasecScores {
          artistic
          conventional
          enterprising
          investigative
          realistic
          social
        }
        workValues {
          workingConditions        
          support
          relationships
          recognition
          independence
          achievement
        }
        typicalExperience {
          percentage
          experience {
            category
            description
            label
          }
        }
        requiredKnowledge {
          id
          score
          knowledge {
            id
            name
            climberVisible
          }
        }
        msMilitaryTraining        
        msTagline
        msCareerCluster {
          icon {
            url
          }
          name
          id
        }
        msPathway {
          id
          name
        }
        msTextOverview
        msShortDescription
        msJobGear {
          id
          name
          description
          displayImage {
            url
            width
            height
          }
        }
        msPerks {
          id
          name
          description
        }
        msQuirks {
          id
          name
          description
        }
        msSkills {
          id
          name
          description
          percentage
          displayImage {
            url
          }
        }
        msWorkActivities {
          id
          name
          description
          score
          displayImage {
            url
          }
        }
        msThemes
        careerArea {
          name
          id
        }
      }
    }
  }
`;

export const GET_CMS_HAT_CONTENT_MS_V2 = `
  query GetCMSHatContentMSV2($hatId: ID!, $msaId: ID!, $stateId: ID!, $drafts: Boolean, $cacheKey: Int) {
    cmsHatsRegions(hatId: $hatId, msaId: $msaId, stateId: $stateId, drafts: $drafts, cacheKey: $cacheKey) {
      id
      region {
        id
        name
        code
        type
      }
      payRange {
        mean
        seventyFifthPercentile
        twentyFifthPercentile
      }
      demand
      skills {
        percentage
        skill {
          name
          skillType
          powerskill
          powerskillLabel
        }
      }
      hat {
        id
        displayName
        displayImage {
          alt
          url
          sizes {
            hatPage {
              url
            }
            hatCard {
              url
            }
          }
        }
        hatCardImage {
          alt
          smallSquare
          mediumSquare
          smallCard
          mediumCard
          largeCard
          hero
        }
        backgroundImage {
          alt
          url
        }
        jobGearDisplayImage {
          url
        }
        perksQuirksDisplayImage {
          url
        }
        riasecScores {
          artistic
          conventional
          enterprising
          investigative
          realistic
          social
        }
        workValues {
          workingConditions
          support
          relationships
          recognition
          independence
          achievement
        }
        preparationLevel
        requiredKnowledge {
          id
          score
          knowledge {
            id
            name
            climberVisible
          }
        }
        msTagline
        msTextOverview
        msShortDescription
        msCareerCluster {
          id
          name
          icon {
            url
          }
          colorTheme
          productPlan {
            code
          }
        }
        msPathway {
          id
          name
          displayImage {
            url
            alt
          }
          careerCluster {
            id
            name
            icon {
              url
            }
          }
          productPlan {
            code
          }
        }
        msPerks {
          id
          name
          description
          type
        }
        msQuirks {
          id
          name
          description
          type
        }
        msJobGear {
          id
          name
          description
          displayImage {
            url
            width
            height
          }
        }
        msSkills {
          id
          name
          description
          percentage
          displayImage {
            url
          }
        }
        msKnowledge {
          id
          name
          category {
            id
            name
            icon {
              url
            }
          }
          icon {
            url
          }
          description
        }
        msPowerSkills {
          id
          name
          category {
            id
            name
            icon {
              url
            }
          }
          icon {
            url
          }
          description
        }
        msProSkills {
          id
          name
          category {
            id
            name
            icon {
              url
            }
          }
          icon {
            url
          }
          description
        }
        msConnectedCourses {
          id
          name
          icon {
            url
          }
          description
        }
        msKeysToSuccess {
          id
          name
          icon {
            url
          }
          description
        }
        msPopularPaths {
          id
          name
          icon {
            url
          }
          description
        }
        msOtherRoutes {
          id
          name
          icon {
            url
          }
          description
        }
        msWhatCanIDo
        msAfterHighSchoolBlurbs {
          id
          title
          description
          icon {
            url
          }
        }
        alsoLike {
          relatedHat {
            id
            displayName
            displayImage {
              url
              alt
              sizes {
                hatCard {
                  url
                }
              }
            }
            hatCardImage {
              alt
              smallSquare
              mediumSquare
            }
          }
        }
        growth {
          percentChange
        }
        hatPreviewAudio {
          url
        }
        msCareerArea {
          name
          id
        }
        careerArea {
          name
          id
        }
        msThemes
        msMilitaryTraining
        assessments {
          active
          assessment
          assessmentType
          experience
          productPlan {
            code
          }
        }
        hatVideos {
          videoDescription
          hatVideo {
            video {
              streamingUrl
              thumbnailUrl
              caption
              tracks {
                locale
                url
              }
            }
            videoId
            blockType
          }
        }
      }
    }
  }
`;

export const GET_CMS_MS_HAT_DISPLAY = `
  query GetCMSMSHatDisplay($hatId: ID!, $stateId: ID, $msaId: ID, $districtId: ID, $middleSchoolId: String, $drafts: Boolean, $cacheKey: Int) {
    cmsMSHatDisplay(hatId: $hatId, stateId: $stateId, msaId: $msaId, districtId: $districtId, middleSchoolId: $middleSchoolId, drafts: $drafts, cacheKey: $cacheKey) {
      id
      displayName
      hatCardImage {
        alt
        smallSquare
        mediumSquare
        smallCard
        mediumCard
        largeCard
        hero
      }
      backgroundImage {
        alt
        url
      }
      jobGearDisplayImage {
        url
      }
      perksQuirksDisplayImage {
        url
      }
      riasecScores {
        artistic
        conventional
        enterprising
        investigative
        realistic
        social
      }
      workValues {
        workingConditions
        support
        relationships
        recognition
        independence
        achievement
      }
      preparationLevel
      requiredKnowledge {
        id
        score
        knowledge {
          id
          name
          climberVisible
        }
      }
      msTagline
      msTextOverview
      msShortDescription
      msCareerArea {
        id
        name
      }
      msCareerCluster {
        id
        name
        icon {
          url
        }
        colorTheme
        productPlan {
          code
        }
      }
      msPathway {
        id
        name
        displayImage {
          url
          alt
        }
        careerCluster {
          id
          name
          icon {
            url
          }
        }
        productPlan {
          code
        }
      }
      msPerks {
        id
        name
        description
        type
      }
      msQuirks {
        id
        name
        description
        type
      }
      msJobGear {
        id
        name
        description
        displayImage {
          url
          width
          height
        }
      }
      msSkills {
        id
        name
        description
        percentage
        displayImage {
          url
        }
      }
      msKnowledge {
        id
        name
        category {
          id
          name
          icon {
            url
          }
        }
        icon {
          url
        }
        description
      }
      msPowerSkills {
        id
        name
        category {
          id
          name
          icon {
            url
          }
        }
        icon {
          url
        }
        description
      }
      msProSkills {
        id
        name
        category {
          id
          name
          icon {
            url
          }
        }
        icon {
          url
        }
        description
      }
      msConnectedCourses {
        id
        name
        icon {
          url
        }
        description
      }
      msKeysToSuccess {
        id
        name
        icon {
          url
        }
        description
      }
      msPopularPaths {
        id
        name
        icon {
          url
        }
        description
      }
      msOtherRoutes {
        id
        name
        icon {
          url
        }
        description
      }
      msWhatCanIDo
      msAfterHighSchoolBlurbs {
        id
        title
        description
        icon {
          url
        }
      }
      alsoLike {
        relatedHat {
          id
          displayName
          hatCardImage {
            alt
            smallSquare
            mediumSquare
          }
        }
      }
      msThemes
      growth {
        percentChange
      }
      hatPreviewAudio {
        url
      }
      selectedRegionSalary {
        regionName
        regionType
        demand
        payRange {
          mean
          twentyFifthPercentile
          seventyFifthPercentile
        }
      }
      nationalSalary {
        regionName
        regionType
        demand
        payRange {
          mean
          twentyFifthPercentile
          seventyFifthPercentile
        }
      }
      districtPrograms {
        id
        name
        matchType
        matchInfo
        schoolMatchType
        schools {
          id
          name
          matchType
        }
      }
    }
  }
`;

export const GET_CLUSTER_STATUSES = `
  query getClusterStatuses {
    getMyClusterStatuses {
      status   
      clusterId
    }
  }
`;

export const CREATE_OR_UPDATE_WORKSITE_VISIT = `
  mutation createOrUpdateWorkSiteVisit($input: WorkSiteVisitInput!) {
    createOrUpdateWorkSiteVisit(input: $input) {
      visits {
        id
        path
        parentID
        shardID
        worksite
        climberIDs
        visitDate
        visitTime
        visitRatings {
          questionId
          question
          rating
        }
        visitComments
        supervisorName
        supervisorPhone
        createdAt
        updatedAt
        createdBy
      }
      isUpdate
    }
  }
`;

export const DELETE_WORKSITE_VISIT = `
  mutation deleteWorkSiteVisit($input: DeleteWorkSiteVisitInput!) {
    deleteWorkSiteVisit(input: $input)
  }
`;

export const CLEAR_CLIMBER_WORKSITE = `
  mutation clearClimberWorksite($input: ClearClimberWorksiteInput!) {
    clearClimberWorksite(input: $input) {
      success
      message
    }
  }
`;

export const GET_WORKSITE_VISITS_FOR_DISTRICT = `
  query getWorkSiteVisitsForDistrict($parentID: String!) {
    getWorkSiteVisitsForDistrict(parentID: $parentID) {
      id
      path
      parentID
      shardID
      worksite
      climberIDs
      visitDate
      visitTime
      visitRating
      visitComments
      supervisorName
      supervisorPhone
      createdAt
      updatedAt
      createdBy
    }
  }
`;

export const GET_WORKSITE_VISIT_BY_ID = `
  query getWorkSiteVisitById($id: String!) {
    getWorkSiteVisitById(id: $id) {
      id
      path
      parentID
      shardID
      worksite
      climberIDs
      visitDate
      visitTime
      visitRatings {
        questionId
        question
        rating
      }
      visitComments
      supervisorName
      supervisorPhone
      createdAt
      updatedAt
      createdBy
    }
  }
`;

// Career Plan Queries
export const GET_MY_CAREER_PLANS = `
  query getMyCareerPlans {
    getMyCareerPlans {
      id
      pathwayId
      pathwaySentiment {
        pathwayId
        sentiment
        sentimentDate
      }
      hatId
      buildingBlocks {
        buildingBlockId
        connectionText
      }
      nextStepIds
      planStatus
      interestText
      educationPathIds
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
    }
  }
`;

export const GET_CAREER_PLAN = `
  query getCareerPlan($id: ID!) {
    getCareerPlan(id: $id) {
      id
      pathwayId
      pathwaySentiment {
        pathwayId
        sentiment
        sentimentDate
      }
      likedItems
      dislikedItems
      hatId
      buildingBlocks {
        buildingBlockId
        connectionText
      }
      nextStepIds
      planStatus
      interestText
      educationPathIds
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
    
    }
  }
`;

export const CREATE_CAREER_PLAN = `
  mutation createCareerPlan($input: MSCreateCareerPlanInput!) {
    createCareerPlan(input: $input) {
      id
      pathwayId
      pathwaySentiment {
        pathwayId
        sentiment
        sentimentDate
      }
      hatId
      buildingBlocks {
        buildingBlockId
        connectionText
      }
      nextStepIds
      planStatus
      interestText
      educationPathIds
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
    }
  }
`;

export const UPDATE_CAREER_PLAN = `
  mutation updateCareerPlan($input: MSUpdateCareerPlanInput!) {
    updateCareerPlan(input: $input) {
      id
      pathwayId
      pathwaySentiment {
        pathwayId
        sentiment
        sentimentDate
      }
      likedItems
      dislikedItems
      hatId
      buildingBlocks {
        buildingBlockId
        connectionText
      }
      nextStepIds
      planStatus
      interestText
      educationPathIds
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
    }
  }
`;

export const DELETE_CAREER_PLAN = `
  mutation deleteCareerPlan($id: ID!) {
    deleteCareerPlan(id: $id)
  }
`;

export const GET_STUDENT_CAREER_PLAN = `
  query getStudentCareerPlan($climberId: ID!, $careerPlanId: ID!) {
    getStudentCareerPlan(climberId: $climberId, careerPlanId: $careerPlanId) {
      id
      path
      pathwayId
      pathwaySentiment {
        pathwayId
        sentiment
        sentimentDate
      }
      likedItems
      dislikedItems
      hatId      
      buildingBlocks {
        buildingBlockId
        connectionText
      }
      nextStepIds
      planStatus
      interestText
      educationPathIds
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
      climber {
        id
        firstName
        lastName
        preferredID
        catchphrase
      }
      buildingBlocksActivities {
        id
        categoryID
        activityID
        userActivityDescription
        userActivityDuration
        sentiments {
          connectorId
          sentiment
          reason
        }
        createdAt
        updatedAt
      }
      perksQuirksSentiments {
        perksQuirksId
        sentiment
        reason
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_CAREER_PLAN_STATUS = `
  mutation updateCareerPlanStatus($input: MSUpdateCareerPlanStatusInput!) {
    updateCareerPlanStatus(input: $input) {
      id
      pathwayId
      hatId
      buildingBlocks {
        buildingBlockId
        connectionText
      }
      nextStepIds
      planStatus
      interestText
      educationPathIds
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
    }
  }
`;

// Shout-Out Queries
export const GET_SHOUT_OUTS_FOR_STUDENT = `
  query getShoutOutsForStudent($climberId: ID!) {
    getShoutOutsForStudent(climberId: $climberId) {
      id
      parentID
      climberID
      connectorId
      message
      createdByName
      createdAt
    }
  }
`;

export const GET_MY_SHOUT_OUTS = `
  query getMyShoutOuts {
    getMyShoutOuts {
      id
      parentID
      climberID
      connectorId
      message
      createdByName
      createdAt
      acknowledged
    }
  }
`;

// Shout-Out Mutations
export const ACKNOWLEDGE_SHOUT_OUT = `
  mutation acknowledgeShoutOut($id: ID!) {
    acknowledgeShoutOut(id: $id) {
      id
      acknowledged
    }
  }
`;

export const CREATE_SHOUT_OUT = `
  mutation createShoutOut($input: MSCreateShoutOutInput!) {
    createShoutOut(input: $input) {
      id
      path
      parentID
      climberID
      connectorId
      message
      createdByUserId
      createdByType
      createdByName
      createdAt
    }
  }
`;

// Course Plan Queries
export const GET_MY_COURSE_PLANS = `
  query getMyCoursePlans {
    getMyCoursePlans {
      id
      pathwayId
      pathwaySentiment {
        pathwayId
        sentiment
        sentimentDate
      }
      planStatus
      likedItems
      dislikedItems
      programId
      programName
      districtPathwayId
      districtPathwayName
      skipDistrictPathwayStep
      noMatchReason
      cteCourseSequence {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      coreCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      electiveCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      settingsVersionId
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
    }
  }
`;

export const GET_COURSE_PLAN = `
  query getCoursePlan($id: ID!) {
    getCoursePlan(id: $id) {
      id
      pathwayId
      pathwaySentiment {
        pathwayId
        sentiment
        sentimentDate
      }
      planStatus
      likedItems
      dislikedItems
      programId
      programName
      districtPathwayId
      districtPathwayName
      skipDistrictPathwayStep
      noMatchReason
      cteCourseSequence {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      coreCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      electiveCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      settingsVersionId
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
    }
  }
`;

export const GET_STUDENT_COURSE_PLAN = `
  query getStudentCoursePlan($climberId: ID!, $coursePlanId: ID!) {
    getStudentCoursePlan(climberId: $climberId, coursePlanId: $coursePlanId) {
      id
      path
      pathwayId
      schoolId
      pathwaySentiment {
        pathwayId
        sentiment
        sentimentDate
      }
      planStatus
      likedItems
      dislikedItems
      programId
      programName
      districtPathwayId
      districtPathwayName
      skipDistrictPathwayStep
      noMatchReason
      cteCourseSequence {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      coreCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      electiveCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
      climber {
        id
        firstName
        lastName
        preferredID
        catchphrase
      }
    }
  }
`;

export const CREATE_COURSE_PLAN = `
  mutation createCoursePlan($input: MSCreateCoursePlanInput!) {
    createCoursePlan(input: $input) {
      id
      pathwayId
      pathwaySentiment {
        pathwayId
        sentiment
        sentimentDate
      }
      planStatus
      likedItems
      dislikedItems
      programId
      programName
      districtPathwayId
      districtPathwayName
      skipDistrictPathwayStep
      noMatchReason
      cteCourseSequence {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      coreCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      electiveCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      settingsVersionId
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
    }
  }
`;

export const UPDATE_COURSE_PLAN = `
  mutation updateCoursePlan($input: MSUpdateCoursePlanInput!) {
    updateCoursePlan(input: $input) {
      id
      pathwayId
      pathwaySentiment {
        pathwayId
        sentiment
        sentimentDate
      }
      planStatus
      likedItems
      dislikedItems
      programId
      programName
      districtPathwayId
      districtPathwayName
      skipDistrictPathwayStep
      noMatchReason
      cteCourseSequence {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      coreCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      electiveCourseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      settingsVersionId
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
    }
  }
`;

export const DELETE_COURSE_PLAN = `
  mutation deleteCoursePlan($id: ID!) {
    deleteCoursePlan(id: $id)
  }
`;

export const UPDATE_COURSE_PLAN_STATUS = `
  mutation updateCoursePlanStatus($input: MSUpdateCoursePlanStatusInput!) {
    updateCoursePlanStatus(input: $input) {
      id
      pathwayId
      planStatus
      createdAt
      updatedAt
      approvedAt
      log {
        personName
        status
        comment
        timestamp
      }
    }
  }
`;

// Course Configuration Queries
export const GET_COURSE_CONFIG = `
  query getCourseConfig {
    getCourseConfig {
      id
      parentID
      path
      shardID
      courseData
      createdAt
      updatedAt
      createdBy
      lastModifiedBy
    }
  }
`;

export const UPDATE_COURSE_CONFIG = `
  mutation updateCourseConfig($input: MSUpdateCourseConfigInput!) {
    updateCourseConfig(input: $input) {
      id
      parentID
      path
      shardID
      courseData
      createdAt
      updatedAt
      createdBy
      lastModifiedBy
    }
  }
`;

export const GET_COURSE_PLAN_OPTIONS_FOR_SCHOOL = `
  query getCoursePlanOptionsForSchool($schoolId: ID!, $settingsVersionId: String) {
    getCoursePlanOptionsForSchool(schoolId: $schoolId, settingsVersionId: $settingsVersionId) {
      availablePrograms {
        programId
        programName
        matchType
        districtPathwayIds
      }
      districtPathways {
        id
        name
        pathwayType
        color
        cmsPathways {
          pathwayId
          matchType
        }
      }
      courseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      courses {
        id
        name
        credits
      }
      settingsVersionId
    }
  }
`;

export const GET_COURSE_PLAN_OPTIONS_FOR_SCHOOL_WITHOUT_VERSION = `
  query getCoursePlanOptionsForSchool($schoolId: ID!) {
    getCoursePlanOptionsForSchool(schoolId: $schoolId) {
      availablePrograms {
        programId
        programName
        matchType
        districtPathwayIds
      }
      districtPathways {
        id
        name
        pathwayType
        color
        cmsPathways {
          pathwayId
          matchType
        }
      }
      courseSequences {
        id
        name
        description
        programIds
        districtPathwayIds
        courses {
          courseId
          grade
        }
      }
      courses {
        id
        name
        credits
      }
      settingsVersionId
    }
  }
`;

export const ROSTER_SEARCH = `
  query rosterSearch($input: RosterSearchInput!) {
    rosterSearch(input: $input) {
      users {
        climberId
        firstName
        lastName
        email
        preferredId
        schools {
          schoolId
          schoolName
        }
        sections {
          sectionId
          sectionName
          schoolId
        }
      }
      pagination {
        total
        limit
        offset
        hasMore
      }
    }
  }
`;

export const USER_STATS = `
  query userStats($input: UserStatsInput!) {
    userStats(input: $input) {
      laddersCompleted
      climbsCompleted
      hatsHeardOf
      hatsLoved
      hatsLiked
      pathwaysLoved
      pathwaysLiked
      logins
      lastLogin
      clusterContentCompleted
    }
  }
`;

export const CAREER_PLAN_PATHWAYS_REPORT = `
  query careerPlanPathwaysReport($input: CareerPlanReportInput!) {
    careerPlanPathwaysReport(input: $input) {
      pathways {
        pathwayId
        uniqueClimberCount
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const CAREER_PLAN_EDUCATION_PATHS_REPORT = `
  query careerPlanEducationPathsReport($input: CareerPlanReportInput!) {
    careerPlanEducationPathsReport(input: $input) {
      educationPaths {
        educationPath
        uniqueClimberCount
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const TOTAL_CLIMBERS_REPORT = `
  query totalClimbersReport($reportInput: ReportInput!) {
    totalClimbersReport(input: $reportInput) {
      totalClimbers
    }
  }
`;

export const MY_TOTAL_CLIMBERS_REPORT = `
  query myTotalClimbersReport($reportInput: ReportInput!) {
    myTotalClimbersReport(input: $reportInput) {
      totalClimbers
    }
  }
`;

export const COURSE_PLAN_PATHWAYS_REPORT = `
  query coursePlanPathwaysReport($input: CoursePlanReportInput!) {
    coursePlanPathwaysReport(input: $input) {
      programs {
        programId
        programName
        pathways {
          districtPathwayId
          districtPathwayName
          uniqueClimberCount
        }
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const GET_PLAN_STATUSES = `
  query GetPlanStatuses($input: PlanStatusReportInput!) {
    planStatusReport(input: $input) {
      cacheInfo {
        generatedAt
        backgroundStarted
      }
      careerPlanStatus {
        schoolId
        schoolName
        totals {
          totalStudents
          draft
          submitted
          revisionsRequested
          approved
        }
        teachers {
          teacherId
          teacherName
          counts {
            totalStudents
            draft
            submitted
            revisionsRequested
            approved
          }
        }
      }
      coursePlanStatus {
        schoolId
        schoolName
        totals {
          totalStudents
          draft
          submitted
          revisionsRequested
          approved
        }
        teachers {
          teacherId
          teacherName
          counts {
            totalStudents
            draft
            submitted
            revisionsRequested
            approved
          }
        }
      }
    }
  }
`;

export const SITE_VISIT_TEACHER_REPORT = `
  query SiteVisitTeacherReport($input: SiteVisitTeacherReportInput!) {
    siteVisitTeacherReport(input: $input) {
      climbers {
        climber
        id
        firstName
        lastName
        schoolId
        grade
        sectionId
        teacherFirst
        teacherLast
        teacherId
        visit1
        visit2
        visit3
        visit4
        visit5
        visit6
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const CERTIFICATE_REPORT = `
  query CertificateReport($input: CertificateReportInput!) {
    certificateReport(input: $input) {
      sites {
        siteId
        siteName
        groups {
          groupId
          groupName
          totalClimbersCount
          awardCompleteCount
        }
      }
      completionsByWeek {
        weekStart
        count
      }
      totalUniqueClimbers
      totalUniqueCompleted
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const CERTIFICATE_CLASS_REPORT = `
  query CertificateClassReport($input: CertificateClassReportInput!) {
    certificateClassReport(input: $input) {
      sectionName
      schoolName
      climbers {
        climberId
        firstName
        lastName
        email
        preferredId
        completed
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

// Career Confidence Check-in Queries
export const GET_LAST_CAREER_CONFIDENCE_CHECKIN = `
  query getLastCareerConfidenceCheckin {
    getLastCareerConfidenceCheckin {
      id
      careerStage
      careerConfidence
      changeExplanation
      createdAt
      isFromOnboarding
    }
  }
`;

export const SAVE_CAREER_CONFIDENCE_CHECKIN = `
  mutation saveCareerConfidenceCheckin($input: MSSaveCareerConfidenceCheckinInput!) {
    saveCareerConfidenceCheckin(input: $input) {
      id
      careerStage
      careerConfidence
      changeExplanation
      createdAt
      isFromOnboarding
    }
  }
`;

export const GET_SESSION_BY_PARENT_ID = `
  query getSessionByParentId($parentID: String!) {
    getSessionByParentId(parentID: $parentID) {
      id
      parentID
      startDate
      endDate
      name
      type
      state
      path
      shardID
      contractTTL
    }
  }
`;

export const GET_SESSIONS_BY_PARENT_ID = `
  query getSessionsByParentId($parentID: String!) {
    getSessionsByParentId(parentID: $parentID) {
      id
      parentID
      startDate
      endDate
      name
      type
      state
      path
      shardID
      contractTTL
    }
  }
`;

export const GET_SESSION_BY_SECTION_ID = `
  query getSessionBySectionId($sectionID: String!) {
    getSessionBySectionId(sectionID: $sectionID) {
      id
      parentID
      startDate
      endDate
      name
      type
      state
      path
      shardID
      contractTTL
    }
  }
`;

export const PATHWAY_INTERESTS_REPORT = `
  query PathwayInterestsReport($input: PathwayInterestsReportInput!) {
    pathwayInterestsReport(input: $input) {
      allPathways {
        pathwayId
        pathwayName
      }
      climbers {
        id
        preferredId
        firstName
        lastName
        schoolName
        grade
        sectionName
        pathwayResponses {
          pathwayId
          pathwayName
          response
        }
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const CLUSTER_PROGRESS_REPORT = `
  query ClusterProgressReport($input: ClusterProgressReportInput!) {
    clusterProgressReport(input: $input) {
      totalClimbers
      clusterStats {
        clusterId
        clusterName
        exploringCount
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const CLUSTER_DETAIL_REPORT = `
  query ClusterDetailReport($input: ClusterDetailReportInput!) {
    clusterDetailReport(input: $input) {
      climbers {
        id
        preferredId
        firstName
        lastName
        pathwaysRatedCount
        ratedPathways
        clusterXp
      }
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const DISTRICT_STATS_REPORT = `
  query districtStatsReport($input: DistrictStatsInput!) {
    districtStatsReport(input: $input) {
      schoolCount
      sectionCount
      coachCount
      cacheInfo {
        generatedAt
        backgroundStarted
      }
    }
  }
`;

export const COMPLETE_COURSE = `
  mutation completeCourse($input: CompleteCourseInput!) {
    completeCourse(input: $input) {
      id
      courseID
      climberID
      parentID
      completedAt
      path
      shardID
    }
  }
`;

export const GET_MY_COURSE_COMPLETIONS = `
  query getMyCourseCompletions {
    getMyCourseCompletions {
      completedAt
      id
      path
      shardID
      courseID
    }
  }
`;

export const GET_COURSE_COMPLETIONS_BY_PARENT_ID = `
  query getCourseCompletionsByParentID($parentID: String!) {
    getCourseCompletionsByParentID(parentID: $parentID) {
      completedAt
      id
      path
      shardID
      courseID
      parentID
      climberID
    }
  }
`;

export const GET_CMS_BANNERS = `
  query getCMSBanners($cacheKey: Int) {
    cmsBanners(cacheKey: $cacheKey) {
      id
      active
      title
      description
      image {
        url
        alt
      }
      startDate
      endDate
      paths
      productPlans
    }
  }
`;
